import { apiClient } from './index';

export const getCollections = () => {
  return apiClient
    .get(`/general/home/products`)
    .then((res) => res.data);
};